import React from "react";
import PropTypes from "prop-types";
import AlertComponent from "../../../../_metronic/_helpers/AlertComponent";
// eslint-disable-next-line no-restricted-imports
import {makeStyles} from "@material-ui/core/styles";
import {format} from "date-fns";
// eslint-disable-next-line no-restricted-imports
import {azAZ} from '@material-ui/core/locale';

import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Tooltip,
    CircularProgress, TableSortLabel,
    createMuiTheme,
    ThemeProvider,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination/index";
import EyeIcon from "@material-ui/icons/RemoveRedEye";

const theme = createMuiTheme(azAZ);

const headRows = [
    {
        id: "code",
        numeric: false,
        disablePadding: true,
        label: "Tur kodu",
    },
    {
        id: "expiredDate",
        numeric: false,
        disablePadding: true,
        label: "Mərcin bitmə tarixi",
    },
    {
        id: "resultedDate",
        numeric: false,
        disablePadding: true,
        label: "Turun bitmə tarixi",
    },
    {
        id: "product.Name",
        numeric: false,
        disablePadding: true,
        label: "Məhsulun adı",
    },
    {
        id: "totalAmount",
        numeric: false,
        disablePadding: true,
        label: "Hovuz məbləği",
    },
    {
        id: "status",
        numeric: false,
        disablePadding: true,
        label: "Turun statusu",
    },
    {
        id: "operations",
        numeric: false,
        disablePadding: true,
        label: "Nəticələr",
    },
];

function EnhancedTableHead({onRequestSort, sortField, orderBy}) {
    return (
        <TableHead>
            <TableRow>
                {headRows.map((row, index) => {
                    if (row.id === "operations") {
                        return (
                            <TableCell key={index}
                                       align="center">
                                <div>
                                    {row.label}
                                </div>
                            </TableCell>
                        )
                    } else {
                        return (
                            <TableCell sortDirection={sortField === row.id ? "asc" : false} key={index}
                                       align={row.numeric ? "right" : "left"}>
                                <TableSortLabel active={sortField === row.id} direction={orderBy ? "desc" : "asc"}
                                                onClick={() => {
                                                    onRequestSort(row.id)
                                                }}>
                                    {row.label}
                                </TableSortLabel>
                            </TableCell>
                        )
                    }
                })}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        marginTop: theme.spacing(3),
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        overflowX: "auto",
    },
    progresRoot: {
        width: "100%",
        padding: "32px 16px",
    },
    progress: {
        margin: "auto",
        display: "block",
        color: "#e2241b",
    },
}));

export default function EnhancedTable({
                                          groups,
                                          isLoading,
                                          isError,
                                          setChooseGroupId,
                                          setOpenView,
                                          deleteGroupsIds,
                                          setDeleteGroupsIds,
                                          sortField,
                                          setSortField,
                                          orderBy,
                                          setOrderBy,
                                          totalCount,
                                          setSkip,
                                          take,
                                          setTake,
                                      }) {
    const classes = useStyles();


    function handleSelectAllClick(event) {
        if (event.target.checked) {
            const newSelecteds = groups.map((n) => n.id);
            setDeleteGroupsIds(newSelecteds);
            return;
        }
        setDeleteGroupsIds([]);
    }

    const isSelected = (name) => deleteGroupsIds.indexOf(name) !== -1;

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleRequestSort = (field) => {

        const isOrder = (field === sortField && !orderBy)

        setSortField(field);
        setOrderBy(isOrder);
        setTake(10);
        setRowsPerPage(10);
        setSkip(0);
        setPage(0);

    };

    function handleChangePage(event, newPage) {
        setPage(newPage);
        setSkip(newPage * take);
    }

    function handleChangeRowsPerPage(event) {
        setRowsPerPage(+event.target.value);
        setTake(+event.target.value);
        setPage(0);
        setSkip(0);
    }

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                {isLoading && (
                    <div className={classes.progresRoot}>
                        <CircularProgress className={classes.progress}/>
                    </div>
                )}
                <div className={classes.tableWrapper}>
                    {groups.length ? (
                        <Table className={classes.table} aria-labelledby="tableTitle">
                            <EnhancedTableHead
                                numSelected={deleteGroupsIds.length}
                                onSelectAllClick={handleSelectAllClick}
                                rowCount={groups.length}
                                onRequestSort={handleRequestSort}
                                sortField={sortField}
                                orderBy={orderBy}
                            />
                            <TableBody>
                                {groups.map((row, index) => {
                                    const isItemSelected = isSelected(row.id);
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={index}
                                            selected={isItemSelected}
                                        >
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.code}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.expiredDate ? format(new Date(row.expiredDate), 'dd MM yyyy HH:mm') : ""}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.resultedDate ? format(new Date(row.resultedDate), 'dd MM yyyy HH:mm') : ""}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.productName}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.totalAmount}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.isResulted ? "Bitib" : "Aktiv"}
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                scope="row"
                                                padding="none"
                                            >
                                                <div className="d-flex justify-content-center">
                                                    <Tooltip title="Göstər" placement="top">
                                                        <button
                                                            aria-label="view"
                                                            className="btn btn-sm btn-icon btn-bg-light btn-text-info btn-hover-info mr-2"
                                                            onClick={() => {
                                                                setChooseGroupId(row.id);
                                                                setOpenView();
                                                            }}
                                                        >
                                                            <EyeIcon/>
                                                        </button>
                                                    </Tooltip>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    ) : !groups.length && !isLoading && !isError ? (
                        <AlertComponent variant="info" message="Məlumat tapılmadı."/>
                    ) : (!isLoading && isError && (!isLoading && isError && (<AlertComponent
                        variant="danger"
                        message="Xəta baş verdi."
                    />)))}
                </div>
                {totalCount > 10 && (
                    <ThemeProvider theme={theme}>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={totalCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            backIconButtonProps={{
                                "aria-label": "Previous Page",
                            }}
                            nextIconButtonProps={{
                                "aria-label": "Next Page",
                            }}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </ThemeProvider>
                )}
            </Paper>
        </div>
    );
}
